import { render, staticRenderFns } from "./reminderList.vue?vue&type=template&id=4f8e5dcc&scoped=true"
import script from "./reminderList.vue?vue&type=script&lang=js"
export * from "./reminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e5dcc",
  null
  
)

export default component.exports